import React, {Component} from 'react';
import {connect}          from 'react-redux';
import {GetRankingCurso} from '../actions/turmaAction';
import { SetError }       from '../actions/authenticActions';

class ComboTurma extends Component {

    constructor(props){
        super(props);
        this.state = { carregando : "Carregando...", listaTurma:[] }
    }

    componentWillMount() {
        this.props.GetRankingCurso(this.props.session.id).then((response) => {
            this.setState({carregando: "Selecione...", listaTurma: response.payload.data})
        }).catch((error) =>{
            this.props.SetError(500);
          });
    }

    renderSelectTurma(){
        return this.state.listaTurma.map((elem,i) =>{ 
            return  <option key={i} value={elem.cur_id}>{elem.cur_nome}</option>
        });
    }

    render() {
                return (
                        <div>
                            <select
                            name          = "select_turma"
                            className     = "form-control"
                            onChange      = {this.props.funcaoChange}
                            >
                            <option value = ""> {this.state.carregando} </option>
                            {this.state.listaTurma ? this.renderSelectTurma() : ""}
                            </select>
                        </div>
                        );
              }
}

function mapStateToProps(state) {

    return {session: state.auth.session}
}


export default connect(mapStateToProps, {GetRankingCurso, SetError})(ComboTurma);



// WEBPACK FOOTER //
// ./src/container/renderComboCurso.js